var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"column",on:{"click":_vm.toService}},[_c('img',{attrs:{"src":require("@/assets/images/周边服务.png"),"alt":""}})]),_c('div',{staticClass:"line"}),_c('ThingsAround')],1)}
var staticRenderFns = []

export { render, staticRenderFns }